import { API } from "aws-amplify";
import { getBuilding } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_BUILDING: APITypes.Building = {
  id: "",
  street: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  name: "",
  propertyID: "",
  price: null,
  numBedroom: "",
  numBathroom: "",
  size: "",
  contact: "",
  description: "",
  actualRentPaymentDate: "",
  __typename: "Building",
  createdAt: "",
  updatedAt: "",
  status: APITypes.BuildingStatusType.None,
  _version: 0,
  _lastChangedAt: 0,
};

export const getBuildingDetails = async (buildingID: string) => {
  try {
    const response = (await API.graphql({
      query: getBuilding,
      variables: { id: buildingID },
    })) as { data?: APITypes.GetBuildingQuery };

    if (!response.data?.getBuilding) {
      throw new Error("Building not found");
    } else if (response.data?.getBuilding === null) {
      throw new Error("Building not found");
    }

    return {
      success: true,
      data: response.data.getBuilding || EMPTY_BUILDING,
    };
  } catch (error) {
    console.error("Error fetching building details:", error);
    return {
      success: false,
      data: EMPTY_BUILDING,
      error,
    };
  }
};
